module.exports = __webpack_public_path__ + "static/Eyeglasss5_5-d19fe1784e006b3fb9c904a6305d89ee.png";